import { render, staticRenderFns } from "./view-global-ids-collapsible.vue?vue&type=template&id=2c6392d4"
import script from "./view-global-ids-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./view-global-ids-collapsible.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6392d4')) {
      api.createRecord('2c6392d4', component.options)
    } else {
      api.reload('2c6392d4', component.options)
    }
    module.hot.accept("./view-global-ids-collapsible.vue?vue&type=template&id=2c6392d4", function () {
      api.rerender('2c6392d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/view-global-ids-collapsible/view-global-ids-collapsible.vue"
export default component.exports